require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-data-structures-learn-how-a-stack-works.json") })
        }
      }, "path---coding-interview-prep-data-structures-learn-how-a-stack-works");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-data-structures-learn-how-a-stack-works!./.cache/json/coding-interview-prep-data-structures-learn-how-a-stack-works.json
// module id = 1336
// module chunks = 231608221292675